<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox">
        <el-form-item label="日期:">
          <el-date-picker
            v-model="searchFrom.dates"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="客户名称:" >
          <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
        </el-form-item>
        <el-form-item label="所属仓库:"  v-if="userType==1">
          <el-select  v-model="searchFrom.organizationName" filterable placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in cklist" :label="item.remark" :value="item.remark" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-button type="primary" v-if="btnFlg[0]"  size="mini" @click="searchFn">查询</el-button>
          <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
          <el-button type="primary" size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
          <!-- <el-button type="primary" v-if="btnFlg[1]" @click="addFn" size="mini" >新增</el-button>
          <el-button type="primary" v-if="btnFlg[2]" @click="delFn" size="mini" >删除</el-button> -->
          <el-form-item style="padding-left: 10px;">
            <p class="margin0">库存量合计:<span class="red">{{tongji.allWeight}}</span>吨</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent" @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="所属仓库"   min-width="220"></el-table-column>
       <el-table-column prop="date" label="日期" :formatter="dateFormat" width="170"></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称"   min-width="220"></el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="stockWeight" label="库存量(吨)"  min-width="220"></el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人"  min-width="120"></el-table-column> -->
      <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="isAdd?'添加':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="850px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="addForm" :model="addForm"  class="demo-form-inline jiaoyan"  label-width="110px"  size="mini"  >
          <el-form-item label="日期" prop="date" >
              <el-date-picker  style="width: 200px"  v-model="addForm.date"  format="yyyy-MM-dd"   value-format="timestamp"  type="date"   ></el-date-picker>
          </el-form-item>
           <el-table :data="addForm.details" ref="table"   bordersize="mini" class="table" max-height="500px" style="width: 100%" center border   >
            <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
           <el-table-column label="" min-width="120">
              <template slot="header" >
                <div><span class="red" >*</span>客户名称</div>
              </template>
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'details.' +scope.$index+ '.customerName'" :key="scope.$index" :rules="rules.customerName"  class="table_error jiage">
                    <el-select placeholder="请选择" value-key="tenantCode"  filterable allow-create
                      default-first-option v-model="scope.row.customerName">
                        <el-option v-for="item in kehuList" :key="item.customerName" :label="item.customerName" :value="item.customerName"></el-option>
                      </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="" min-width="120">
              <template slot="header" >
                <div><span class="red" >*</span>库存(吨)</div>
              </template>
              <template slot-scope="scope">
                <div>
                  <el-form-item label="" :prop="'details.' +scope.$index+ '.stockWeight'" :key="scope.$index" :rules="rules.stockWeight"  class="table_error jiage">
                    <el-input  placeholder=""  v-number-input.float="3"  maxlength="8" v-model="scope.row.stockWeight"  ></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="addGoodFn(scope.row)">新增</el-button>
                <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed, getLastWeekDates } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findDisplayStockList, findDisplayStockStatistics, deleteDisplayStock, addDisplayStockList, findCustomerDropDownBox, findShWhList } from '@/api/data-center-server'
export default {
  components: {
  },
  data () {
    return {
      isDain: true,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        stockWeight: [
          { required: true, message: '库存', trigger: 'blur' }
        ]
      },
      isAdd: false,
      addFlag: false,
      addForm: { details: [{}] },
      kehuList: [],
      tongji: {},
      userType: localStorage.getItem('userType'),
      btnFlg: [],
      btnIdArr: ['00CM0L0100', '00CM0L0200', '00CM0L0300']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    findShWhList().then(res => {
      this.cklist = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
    this.$set(this.searchFrom, 'dates', getLastWeekDates('riqi'))
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 添加
    addFn () {
      findCustomerDropDownBox().then(res => {
        this.kehuList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
      this.addForm = { details: [{}] }
      this.isAdd = true
      this.addFlag = true
    },
    // 弹框添加货物
    addGoodFn (row) {
      let json = { ...row }
      this.addForm.details.push(json)
      this.weightFn()
    },
    // 弹框删除货物
    delGoodFn (index) {
      if (this.addForm.details.length == 1) {
        this.$alert('最后一条货物不能删除', '系统提示')
        return
      }
      let id = this.addForm.details[index].id
      if (id) {
        this.delGoodIds.push(id)
      }
      this.addForm.details.splice(index, 1)
    },
    saveFn () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let arrName = this.addForm.details.map(itme => itme.customerName)
          if (new Set(arrName).size != arrName.length) {
            this.$alert('同一日期、同一客户库存数据唯一，不能出现多条', '系统提示')
            loading.close()
            return
          }
          this.addForm.details.forEach(item => {
            item.date = this.addForm.date
            item.stockNumber = 0
          })
          addDisplayStockList(this.addForm.details).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteDisplayStock({
          ids: selectData.map(item => item.id)
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.wmsCenter + '/displayStock/exportInventoryList',
        form,
        '库存列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.dates) {
        this.$set(this.searchFrom, 'startDate', this.searchFrom.dates[0])
        this.$set(this.searchFrom, 'endDate', this.searchFrom.dates[1])
      } else {
        this.$set(this.searchFrom, 'startDate', null)
        this.$set(this.searchFrom, 'endDate', null)
      }
      this.loading = true
      findDisplayStockList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
      findDisplayStockStatistics(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'dates', getLastWeekDates('riqi'))
    },
    closeDialog () {
      this.addForm = {
      }
      this.imgLis = []
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.addForm.quantity && this.addForm.amount) {
          this.$set(this.addForm, 'unitPrice', toFixed(this.addForm.amount / this.addForm.quantity, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 200px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
 /deep/.el-form {
  width: 100%;
 }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
